import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const unlockInput = this.element.querySelector('input[name="unlock"]')
    unlockInput.value = event.target.checked ? "true" : "false"
    this.element.requestSubmit()
  }
}
